import _classCallCheck from "/mnt/ramdisk/app/solvuu-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/ramdisk/app/solvuu-ui/node_modules/@babel/runtime/helpers/esm/createClass";

// tslint:disable-next-line
var XSAdd = require('ml-xsadd');

import _choice from './choice';
/**
 * @classdesc Random class
 */

var Random =
/*#__PURE__*/
function () {
  /**
   * @param [seedOrRandom=Math.random] - Control the random number generator used by the Random class instance. Pass a random number generator function with a uniform distribution over the half-open interval [0, 1[. If seed will pass it to ml-xsadd to create a seeded random number generator. If undefined will use Math.random.
   */
  function Random() {
    var seedOrRandom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Math.random;

    _classCallCheck(this, Random);

    if (typeof seedOrRandom === 'number') {
      var xsadd = new XSAdd(seedOrRandom);
      this.randomGenerator = xsadd.random;
    } else {
      this.randomGenerator = seedOrRandom;
    }
  }

  _createClass(Random, [{
    key: "choice",
    value: function choice(values, options) {
      if (typeof values === 'number') {
        return _choice(values, options, this.randomGenerator);
      }

      return _choice(values, options, this.randomGenerator);
    }
  }, {
    key: "random",
    value: function random() {
      return this.randomGenerator();
    }
  }]);

  return Random;
}();

export { Random as default };